import React, {useState, useEffect} from 'react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {MarketRow} from './marketrow';
import { Table } from 'semantic-ui-react'

export function Marketlist(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [showMarkettype, setShowMarkettype] = useState({});

    let markets = Object.values(props.markets);
    markets.sort((a, b) => a.canvas.type.localeCompare(b.canvas.type) || a.canvas.id.localeCompare(b.canvas.id));

    let marketcntByType = {};
    let namesOfMarkettypes = {};

    markets.forEach((market) => {
        if(typeof marketcntByType[market.canvas.type] === 'undefined')
            marketcntByType[market.canvas.type] = 0;
        
        marketcntByType[market.canvas.type]++;

        if(typeof namesOfMarkettypes[market.canvas.type] === 'undefined')
            namesOfMarkettypes[market.canvas.type] = {};
        
        namesOfMarkettypes[market.canvas.type][market.canvas.name] = true;
    })

    return (
        <Table compact columns={5} fixed={true}>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Type</Table.HeaderCell>
                    <Table.HeaderCell>UID</Table.HeaderCell>
                    <Table.HeaderCell>Canvas-ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Beschreibung</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
            {
                (markets).map((market, idx) => <MarketRow toggleShowMarkets={(e) => {
                    setShowMarkettype({
                        ...showMarkettype,
                        [market.canvas.type]: (typeof showMarkettype[market.canvas.type] === 'undefined' || showMarkettype[market.canvas.type] === false)
                    });
                }} namesOfType={Object.keys(namesOfMarkettypes[market.canvas.type])} showMarkets={(typeof showMarkettype[market.canvas.type] !== 'undefined' && showMarkettype[market.canvas.type])} marketsOfType={marketcntByType[market.canvas.type]} marketTypeHasChanged={idx === 0 || markets[idx].canvas.type !== markets[idx - 1].canvas.type} key={market.uid} market={market} onClickMarket={(e) => {
                    if(typeof props.onClickMarket !== 'undefined')
                        props.onClickMarket(market);
                }} onClickType={(e) => {
                    if(typeof props.onClickType !== 'undefined')
                        props.onClickType(market);
                }} />)
            }
            </Table.Body>
        </Table>
    );
}